export const COLOCATION_TOLERANCE = 1e-5

type Coordinate = number | null | undefined

export function areColocatedCoordinates(
  latitude1: Coordinate,
  longitude1: Coordinate,
  latitude2: Coordinate,
  longitude2: Coordinate,
): boolean {
  return (
    Math.abs((latitude1 ?? 0) - (latitude2 ?? 0)) < COLOCATION_TOLERANCE &&
    Math.abs((longitude1 ?? 0) - (longitude2 ?? 0)) < COLOCATION_TOLERANCE
  )
}

export const cellIndex = (value: Coordinate) =>
  Math.floor((value ?? 0) / COLOCATION_TOLERANCE)

export const cellKey = (latitude: Coordinate, longitude: Coordinate) =>
  `${cellIndex(latitude)}|${cellIndex(longitude)}`

export function neighbouringCellKeys(
  latitude: Coordinate,
  longitude: Coordinate,
): string[] {
  const latitudeCell = cellIndex(latitude)
  const longitudeCell = cellIndex(longitude)
  const keys: string[] = []

  for (let latitudeOffset = -1; latitudeOffset <= 1; latitudeOffset++) {
    for (let longitudeOffset = -1; longitudeOffset <= 1; longitudeOffset++) {
      keys.push(
        `${latitudeCell + latitudeOffset}|${longitudeCell + longitudeOffset}`,
      )
    }
  }

  return keys
}
